<template>
  <el-card class="box-card" v-loading="loading" shadow="never">
    <div slot="header" class="clearfix">
      <span>超过2万条数据的导出在这里下载,刷新查看最新进度</span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="reload">刷新</el-button>
    </div>
    <div v-if="downloadsList.length" class="downloadsList">
      <div class="downloads-item" v-for="item in downloadsList" :key="item.id">
        <div class="details">
          <div class="title-area">
            <el-button type="text" @click="linkClick(item)" v-if="item.progress != 100">{{item.fileName}}</el-button>
            <el-link type="primary" v-else :href="`/Account/_public/excelServlet.html?excelPath=${item.path}&excelName=${encodeURIComponent(encodeURIComponent(item.fileName.split('.')[0]))}`">{{item.fileName}}</el-link>
          </div>
          <div class="gridcell">{{item.entryDate}} {{item.entryTime}}</div>
          <div class="controls">
            <el-progress :text-inside="true" :stroke-width="16" :percentage="item.progress || 0"></el-progress>
          </div>
        </div>
        <div class="more-options">
          <div class="gridcell">
            <div class="remove" @click="deleteFileDownload(item)">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>
  </el-card>
    
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      downloadsList: []
    }
  },
  created() {
    this.getDownloadsList()
  },
  methods: {
    getDownloadsList() {
      this.loading = true
      this.$http.post('/Account/fileDownload/selectFileDownloadList.html', this.Qs.stringify({ })).then(({ data: res }) => {
        this.loading = false
        if (res.code != 0) {
          return this.$message.error(res.message)
        }
        this.downloadsList = res.data
      })
    },
    async deleteFileDownload({ id, fileType, progress = 0 }) {
      if (progress != 100) {
        this.$alert('请等待进度100%后删除，刷新查看最新进度', '提示', {
          confirmButtonText: '确定',
          callback() {
            location.reload()
          }
        })
        return false
      }
      const confirmResult = await this.$confirm('是否删除此文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消删除')
      const loading = this.$loading({
        lock: true,
        text: '删除中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$http.post('/Account/fileDownload/deleteFileDownload.html', this.Qs.stringify({ fileID: id, fileType })).then(({ data: res }) => {
        loading.close()
        if (res.code != 0) return this.$alert(res.message, '提示', {
          confirmButtonText: '确定'
        })
        this.$message({
          type: 'success',
          message: res.message
        });
        this.getDownloadsList()
      })
    },
    reload() {
      location.reload()
    },
    linkClick({ progress = 0 }) {
      if (progress != 100) {
        this.$alert('请等待进度100%后下载，刷新查看最新进度', '提示', {
          confirmButtonText: '确定',
          callback() {
            location.reload()
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  ::v-deep .el-card__body {
    padding: 10px 20px;
    height: calc(100% - 55px);
    overflow-y: auto;
    box-sizing: border-box;
  }
}
.downloadsList {
  // min-width: 680px;
  box-sizing: border-box;
  // padding: 10px;
  .downloads-item {
    width: 100%;
    display: flex;
    flex: none;
    margin: 6px auto;
    // min-height: 103px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.6);
    border: 1px rgb(218, 220, 224) solid;
    .details {
      border-inline-start: 1px #d8d8d8 solid;
      display: flex;
      flex: 1;
      flex-direction: column;
      min-width: 0;
      padding-bottom: 12px;
      padding-inline-end: 16px;
      padding-inline-start: 24px;
      padding-top: 16px;
      color: rgba(27, 27, 27, 0.6);
      .gridcell {
        color: rgba(27, 27, 27, 0.6);
        margin-top: 6px;
      }
      .controls {
        margin-top: 6px;
      }
    }
    .more-options {
      display: flex;
      flex-direction: column;
      .gridcell {
        .remove {
          margin: 8px 8px 0 16px;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          cursor: pointer;
          &:hover {
            background-color: rgb(228, 231, 237);
            border-radius: 50%;
          }
        }
      }
    }
  }
}
</style>